<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { vue } from '../../../../main'
import { TYPES as DOCUMENT_TYPES } from '../../document/store'

export default {
  name: 'DocumentMixin',
  created () {
    this.setDocumentList({})
    this.setCoursesList([])
  },
  computed: {
    ...mapGetters({
      documentsList: DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS.list,
      coursesList: DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS.coursesList
    }),
    documentOptions () {
      const options = []
      if (this.documentsList.results && this.documentsList.results.length) {
        this.documentsList.results.forEach(item => {
          options.push({
            value: item.id,
            text: item.name
          })
        })
      }
      return options
    },
    coursesOptions () {
      const options = []
      if (this.coursesList && this.coursesList.length) {
        this.coursesList.forEach(item => {
          options.push({
            value: item.id,
            text: item.name || `${item.title || ''} ${item.subtitle || ''}`.trim()
          })
        })
      }
      return options
    }
  },
  methods: {
    ...mapMutations({
      setDocumentList: DOCUMENT_TYPES.GENERIC.document.document.LIST.MUTATIONS.setList,
      setCoursesList: DOCUMENT_TYPES.GENERIC.document.document.LIST.MUTATIONS.setCoursesList
    }),
    ...mapActions({
      getDocumentList: DOCUMENT_TYPES.GENERIC.document.document.LIST.ACTIONS.setFilters,
      getCoursesList: 'GENERIC/document/document/setCoursesFilters'
    }),
    onSearchDocument (search) {
      if (search.length >= 2) {
        vue.$store.commit('componentLoading', false)
        this.getDocumentList({ filter__name__icontains: search }).then(() => {
          vue.$store.commit('componentLoading', true)
        })
      } else {
        this.setDocumentList({})
      }
    },
    selectDocument (item) {
      this.$set(this.form, 'document', item.value)
      this.$set(this.form, 'document_name', item.text)
    },
    clearDocument () {
      this.$set(this.form, 'document', null)
      this.$set(this.form, 'document_name', null)
    },
    setBaseCertifications (formData) {
      if (this.form.base_certifications) {
        const list = []
        this.form.base_certifications.forEach((row) => list.push(row.value))
        this.$set(formData, 'base_certifications', new Set(list))
      } else {
        this.$set(formData, 'base_certifications', [])
      }
    },
    onSearchBaseCertifications (search, documentId, selectedIds) {
      if (search.length >= 2) {
        vue.$store.commit('componentLoading', false)

        const excludedList = []

        if (documentId) {
          excludedList.push(documentId)
        }

        if (selectedIds && selectedIds.length > 0) {
          excludedList.push(...selectedIds.map(item => item.value))
        }

        const filters = {
          filter__name__icontains: search
        }
        if (excludedList.length > 0) {
          filters.exclude__id__in = excludedList
        }
        this.getDocumentList(filters).then(() => {
          vue.$store.commit('componentLoading', true)
        })
      } else {
        this.setDocumentList({})
      }
    },
    selectBaseCertification (item) {
      const list = this.form.base_certifications || []
      const updated = [...list, item]
      this.$set(this.form, 'base_certifications', updated)
    },
    removeBaseCertification (item) {
      const list = this.form.base_certifications || []
      const updated = list.filter(i => i.value !== item.value)
      this.$set(this.form, 'base_certifications', updated)
    },
    clearBaseCertifications () {
      this.$set(this.form, 'base_certifications', [])
    },
    setCourses (formData) {
      if (this.form.courses) {
        const list = []
        this.form.courses.forEach((row) => list.push(row.value))
        this.$set(formData, 'courses', new Set(list))
      } else {
        this.$set(formData, 'courses', [])
      }
    },
    onSearchCourses (search, selectedIds) {
      if (search.length >= 2) {
        vue.$store.commit('componentLoading', false)

        const excludedList = []

        if (selectedIds) {
          excludedList.push(...selectedIds.map(item => item.value))
        }
        this.getCoursesList({
          filter__name__icontains: search,
          exclude__code__in: excludedList
        }).then(() => {
          vue.$store.commit('componentLoading', true)
        })
      } else {
        this.setCoursesList([])
      }
    },
    selectCourse (item) {
      const list = this.form.courses || []
      const updated = [...list, item]
      this.$set(this.form, 'courses', updated)
    },
    removeCourse (item) {
      const list = this.form.courses || []
      const updated = list.filter(i => i.value !== item.value)
      this.$set(this.form, 'courses', updated)
    },
    clearCourses () {
      this.$set(this.form, 'courses', [])
    }
  }
}
</script>
